// =====================================================
// API — Notas internas del paciente
// =====================================================
import { api } from './client';
import type { PatientNote, PatientNoteEdit } from '../types/patient';

export interface CreatePatientNoteRequest {
  content: string;
  pinned?: boolean;
}

export interface UpdatePatientNoteRequest {
  content?: string;
}

export const patientNotesApi = {
  /** Lista las notas del paciente en el centro activo */
  getByPatient: (patientId: string): Promise<PatientNote[]> =>
    api.get(`/patient-notes/${patientId}`),

  /** Crea nueva nota */
  create: (patientId: string, data: CreatePatientNoteRequest): Promise<PatientNote> =>
    api.post(`/patient-notes/${patientId}`, data),

  /** Edita el contenido de una nota */
  update: (noteId: string, data: UpdatePatientNoteRequest): Promise<PatientNote> =>
    api.patch(`/patient-notes/note/${noteId}`, data),

  /** Fija/desfija una nota */
  togglePin: (noteId: string, pinned: boolean): Promise<PatientNote> =>
    api.patch(`/patient-notes/note/${noteId}/pin`, { pinned }),

  /** Borra (soft delete) una nota */
  remove: (noteId: string): Promise<{ success: boolean }> =>
    api.delete(`/patient-notes/note/${noteId}`),

  /** Histórico de ediciones */
  getEditHistory: (noteId: string): Promise<PatientNoteEdit[]> =>
    api.get(`/patient-notes/note/${noteId}/edits`),
};
